import React from "react";
import { useMediaQuery } from "react-responsive";
import { FaAppStore, FaGithub, FaGooglePlay, FaLink } from "react-icons/fa";

import "./ProjectCard.css";

export default function ProjectCard({ project, style }) {
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  const {
    title,
    description,
    liveUrl,
    githubUrl,
    playStoreUrl,
    appStoreUrl,
    tools,
  } = project;

  const renderUrl = (url, icon) => {
    return (
      url && (
        <a href={url} target="_blank" rel="noreferrer" className="project-link">
          {icon}
        </a>
      )
    );
  };

  return (
    <div
      className="project-card"
      style={
        style || {
          maxWidth: isMobile ? "80vw" : "35vw",
        }
      }
      key={title}
    >
      <h2>{title}</h2>
      <p>{description}</p>
      <ul className="tools-ul">
        {tools.map((tool, index) => (
          <li className="tools-li" key={index}>
            {tool}
          </li>
        ))}
      </ul>
      <div className="project-links">
        {renderUrl(liveUrl, <FaLink className="project-link" size={22} />)}
        {renderUrl(githubUrl, <FaGithub className="project-link" size={22} />)}
        {renderUrl(
          playStoreUrl,
          <FaGooglePlay className="project-link" size={22} />
        )}
        {renderUrl(
          appStoreUrl,
          <FaAppStore className="project-link" size={22} />
        )}
      </div>
    </div>
  );
}
